import styled from 'styled-components/macro';

export const Wrapper = styled.div`
  padding: 25px;
  overflow: auto;
  padding-right: 35px;
`;

export const Title = styled.div`
  margin-bottom: 25px;
`;

export const Buttons = styled.div`
  margin-bottom: 15px;
  display: flex;
  gap: 8px;
`;
